export enum AuthOperationRoleNames {
  PetPass_Admin = 'PetPass_Admin',
  PetPass_CSR = 'PetPass_CSR',
  PetPass_CSR_L2 = 'PetPass_CSR_L2',
  PetPass_Greeter = 'PetPass_Greeter',
  PetPass_DVM = 'PetPass_DVM',
  PetPass_VetTech = 'PetPass_VetTech',
  PetPass_DI = 'PetPass_DI',
  PetPass_Ops_Leader = 'PetPass_Ops_Leader',
  PetPass_ReadOnly = 'PetPass_ReadOnly',
  Admin = 'Admin',
  Veterinarian = 'Veterinarian',
  Veterinary_Technician = 'Veterinary Technician',
  Veterinary_Assistant = 'Veterinary Assistant',
  Hospital_Office_Manager = 'Hospital Office Manager',
  Area_Office_Manager = 'Area Office Manager',
  Concierge_Customer_Service = 'Concierge/Customer Service',
  Hospital_Medical_Leader = 'Hospital Medical Leader',
  Leader_on_Duty = 'Leader on Duty',
  Area_Medical_Director = 'Area Medical Director',
}
